import { Box, BoxProps, styled } from '@mui/material';

const StyledSchedulerWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  border: '0.1rem solid',
  borderColor: theme.palette.border.main,
  borderTopColor: 'transparent',
  borderLeftColor: 'transparent',
  height: 'calc(100vh - 20.8rem)',
}));

export default StyledSchedulerWrapper;
